import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { deleteMAGAE020, getMAGAE020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';

import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';
const MAGAE030 = () => {
    const { id } = useParams();
    const [data, setData] = useState({});

    useEffect(() => {
        if (id) {
            getMAGAE020(id)
                .then(({ data }) => {
                    setData({
                        ...data,
                        seq: id,
                        gubun: data.gubun,
                        title: data.title,
                        bizCompany: data.bizCompany,
                        columnist: data.columnist,
                        dspYN: data.dspYN,
                    });
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAGAE020(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/magae010';
                })
                .catch((error) => console.log(error));
        }
    };
    const textGubunItem = (gubun) => {
        switch (gubun) {
            case 'INTERVIEW':
                return '덴탈탐방';
            case 'COLUMN':
                return '덴탈칼럼';
            case 'QNA':
                return 'QNA';
            default:
                return '';
        }
    };

    return (
        <div className="container dental-magazine">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div id="tableVolunteer" style={{ width: '100%' }}>
                    <div className="vln-mbl">
                        <div className="vln-mgzn__detail">
                            <div className="vln-mgzn__top">
                                <div className="vln-mgzn__lf">
                                    <span className={`vln-mgzn__gb`}>{textGubunItem(data?.gubun)}</span>
                                    <div className="vln-mgzn__tit">
                                        <h3 dangerouslySetInnerHTML={{ __html: data?.title }}></h3>
                                        <p>{data?.bizCompany}</p>
                                    </div>
                                </div>
                                <div className="vln-mgzn__view">조회수 : {data?.visitedCnt}</div>
                            </div>
                            <div
                                className="vln-mgzn__cnt"
                                style={{ height: 'max-content', minHeight: 'auto', borderBottom: 'unset' }}
                                dangerouslySetInnerHTML={{ __html: data?.content }}
                            ></div>
                        </div>
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th style={{ width: '200px' }}>
                                        <span>연자</span>
                                    </th>
                                    <td style={{ borderRight: 'unset' }}>{data?.columnist}</td>
                                </tr>
                                <tr>
                                    <th style={{ width: '200px' }}>
                                        <span>공개여부</span>
                                    </th>
                                    <td style={{ borderRight: 'unset' }}>
                                        {data?.dspYN === 'Y' ? '공개' : data?.dspYN === 'N' ? '비공개' : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div
                            className="bottom-content"
                            style={{ justifyContent: 'start', gap: '15px', marginTop: '0px', border: 'unset' }}
                        >
                            <Link
                                to={'/magae010'}
                                className="button-back-to-list"
                                style={{ padding: '0 23px', height: '30px' }}
                            >
                                목록
                            </Link>
                            <div className="button-form">
                                <button
                                    className="btn btn-primary button-back-to-list button-delete"
                                    onClick={() => {
                                        handleDelete();
                                    }}
                                >
                                    삭제
                                </button>
                            </div>
                            <div className="button-form">
                                <Link to={`/magae020-${id}`} className="btn btn-primary button-save">
                                    수정
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAE030;
